import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indirect-purchaser-states',
  templateUrl: './indirect-purchaser-states.html',
  styleUrls: ['./indirect-purchaser-states.css']
})
export class IndirectPurchaserStates implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
